import { IS_DEMO, IS_LAXMI_HOST, DEMO_BRAND } from './demo';

const LAXMI_BRAND = { name: 'Laxmi Cable Vision', logo: '/crm-logo.png?v=2' };

// Name + logo the CRM shows for itself: Laxmi's own addresses keep Laxmi's, the demo and an
// operator with no company set up yet wear Orvyn, an operator shows their own.
export const resolveBrand = ({ isDemo, isLaxmi, identity }) => {
  if (isDemo) return DEMO_BRAND;
  if (isLaxmi) return LAXMI_BRAND;
  return { name: identity?.name || DEMO_BRAND.name, logo: identity?.logo || DEMO_BRAND.logo };
};

export const brandFor = (identity) => resolveBrand({ isDemo: IS_DEMO, isLaxmi: IS_LAXMI_HOST, identity });
